const REACT_APP_BACKEND_URL= "https://wits-server-63f9765d35d2.herokuapp.com"//"https://ahp-cf6a4ec98497.herokuapp.com";

const REACT_APP_UPLOADS = "https://wits-api.lapa.africa";

const REACT_APP_FRONTEND_URL= process.env.FRONTEND_URL;

const REACT_APP_TOKEN_NAME="_wits_token"

const REACT_APP_ACCOUNT_DATA="_wits_account_data"

const REACT_APP_SESSION_DATA="_wits_session_data"

const REACT_APP_AWS_BUCKET= process.env.AWS_BUCKET;

const REACT_APP_AWS_REGION= process.env.AWS_REGION;

const REACT_APP_AWS_ACCESS_ID= process.env.AWS_ACCESS_ID;

const REACT_APP_AWS_SECRET_KEY= process.env.AWS_SECRET_KEY;

export {
    REACT_APP_BACKEND_URL,
    REACT_APP_FRONTEND_URL,
    REACT_APP_TOKEN_NAME,
    REACT_APP_ACCOUNT_DATA,
    REACT_APP_SESSION_DATA,
    REACT_APP_AWS_BUCKET,
    REACT_APP_AWS_REGION,
    REACT_APP_AWS_ACCESS_ID,
    REACT_APP_AWS_SECRET_KEY,
    REACT_APP_UPLOADS
}